<mat-toolbar class="main-nav">
  <button
    [ngClass]="{'xs': mo.isActive('xs')}"
    [routerLinkActive]="'active'"
    [routerLink]="['/home']"
    class="category"
    color="primary"
    mat-button>
    PROFILE
  </button>
  <button (click)="toggleStarryNight()"
          [ngClass]="{'closed': starryNightOpen, 'xs': mo.isActive('xs')}"
          class="toggle-starry-night-button">
    <mat-icon>brightness_3</mat-icon>
  </button>
  <button
    [ngClass]="{'xs': mo.isActive('xs')}"
    [routerLinkActive]="'active'"
    [routerLink]="['/web']"
    class="category"
    color="primary"
    mat-button>
    PORTFOLIO
  </button>
</mat-toolbar>
<longmoon-starry-night [ngClass]="{'xs': mo.isActive('xs')}"
                       [starryNightOpen]="starryNightOpen"
></longmoon-starry-night>
<div class="content">
  <router-outlet></router-outlet>
</div>
